/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrBalloonEntity } from '../../models/dbr-balloon-entity';

export interface BalloonsControllerGetBalloonsByUserId$Params {
  userId: number;
}

export function balloonsControllerGetBalloonsByUserId(http: HttpClient, rootUrl: string, params: BalloonsControllerGetBalloonsByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrBalloonEntity>>> {
  const rb = new RequestBuilder(rootUrl, balloonsControllerGetBalloonsByUserId.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DbrBalloonEntity>>;
    })
  );
}

balloonsControllerGetBalloonsByUserId.PATH = '/balloons/byuserid/{userId}';
